import React from "react";
import styles from "../../common/AlertCard.scss";
import PaperlessBillingPopup from "../../common/PaperlessBillingPopup";
import PaperlessBillingToggle from "./Presentational/PaperlessBillingToggle";
import PaperlessBillingTurnonPopup from "./Presentational/PaperlessBillingTurnonPopup";
import PaperlessBillingTurnoffPopup from "./Presentational/PaperlessBillingTurnoffPopup";
import ViewEditPaperlessBilling from "./Presentational/ViewEditPaperlessBilling";
import PaperlessBilling from "./PaperlessBilling";
import ConfirmationPopup from "./Presentational/ConfirmationPopup";
import PbBulkEnrollmentPopup from "./Presentational/PbBulkEnrollmentPopup";
import ErrorMessages from "../../common/ErrorMessages";
import BulkEnrollConfPopup from "./Presentational/BulkEnrollConfPopup";
import PaperlessBillingDeEnrollConfirmPopup from "./Presentational/PaperlessBillingDeEnrollConfirmPopup";
import PaperlessBillingContainerHelper from "./PaperlessBillingContainerHelper";
class PaperlessBillingContainer extends React.Component {
   constructor(props) {
    super(props);
    this.state = {
      prefData: "",dropDownData:"",isShowPopup:false,preferenceData:"",preferenceDataAuth:"", serviceAccountData:"",isErrorCard:false, isShowViewEdit:false, hoverData:'', hoverModal:false,hoverPhoneModal:false,hoverType:'',categoryType:'',
      emailOn: null,phoneOn: null,textOn: null,checked: null,isOpen: false,pbEnroll: false,pbDeEnroll: false,displayDialog: false,enrolledCount:null,pbEnrollErrMsg:"",enrollResponse:null,pbBulkEnrollConfirm:"",totalAccounts:0,successCount:0,
      errorPbDeEnrollMsg:"", closePopUp: false,viewEditPopUp: false,enrolledEmail:"",  contractAccountResults:this.props.cpcData.contractAccountResults,errorEnrollFlag:"",errorDeenrollFlag:"", cpcData: this.props.cpcData,turnOff: false, enrollStatus: "",AccType: "",reason: "",primaryEmail: "",lEmail:"",tncChecked: "",reviewObj: [],accountObj: [],
      profileObj: {}, isPbEnrollConfirm: "",isPbDeEnrollConfirm: "",deEnrollConfirmPopup: false,yesCancelDeEnroll: "", isEnrollError: "",checkboxClick: "",inEligibleFlagStatus: "",data: [],emails: [],isLoading: false,currentPage: this.props.cpcPageNumber,startPage: 1,endPage: 10,enrolledCact: null,toggleDisabled:true,failedAccounts:[], pageChangeFlag:false,
};
    this.togglePopup = this.togglePopup.bind(this);
    this.submitClick = PaperlessBillingContainerHelper.submitClick.bind(this), this.submitDeenrollClick= PaperlessBillingContainerHelper.submitDeenrollClick.bind(this);
    this.customerData='';
    this.initialPositionValue = window.getComputedStyle(document.body).position;
    this.imageMail_On=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_MailOn.svg';
    this.imageMail_Off=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_MailOff.svg';
  }
  handleServiceError(error) {
    app.logger.getLogger().info("Paperless Billing Enroll: Handle service error");
    app.logger.getLogger().info(error);
    this.setState({isGlobalError: true});
  }
  componentWillMount(){
    this.customerData=app.appService.getSessionstorage('customerData');
    const updatedState = { ...this.state };
    updatedState.contractAccountResults=this.props.contractAccountResults;
    this.setState(updatedState,()=>{});
  }

  componentWillReceiveProps(nextProps) {
    if (this.props !== nextProps) {
      this.setState(
        {
          prefData: this.props.preferenceData,checked: this.props.preferenceData.email_id.length > 0 ? true : false, contractAccountResults:this.state.cpcData.contractAccountResults,
        },
        () => {
          this.handle();
          this.handleViewEdit();
        }     

      );
    }
  }
componentDidMount() {
    const updatedState = { ...this.state };
    if (this.props.cpcData.contractAccountResults.length > 1) {
       updatedState.AccType = "Multi", this.setState(updatedState);
    }
    else {
      updatedState.AccType = "Single", this.setState(updatedState);

    }
  
  }
  viewEditHandler() {
    window.aUtils.sendAAEvent("button","paperlessBillingView/Edit");
    const updatedState = { ...this.state };
    updatedState.viewEditPopUp = true, this.setState(updatedState, () => { });
    window.scrollTo(0,0);

  }
  cancelConfirmationButtonHandlers() {
    this.setState({ isPbEnrollConfirm: "" }, () => { });
  }
  cancelBulkConfirmationButtonHandlers(){
    this.setState({ pbBulkEnrollConfirm: "" }, () => { });
  }

  checkLoginEmail = () => {
    let isLoginEmail = false;
    let loginEmail = app.appService.getUserInfo().email;

    _.each(this.customerData.emailAddresses, function (record) {
      if (record.email === loginEmail)
        isLoginEmail = true;
      });
  return isLoginEmail;

  }

  //bulk enroll failure counts
  bulkEnrollFailureCounts(response,updatedState){
    let pbEnrollSuccessCount=0; 
     _.each(response, function (record) {
      if (record.paperlessBillingStatus === "Success")
      pbEnrollSuccessCount++;
      else{
        updatedState.failedAccounts.push(record.accountNumber); } });
      if(response.length===pbEnrollSuccessCount){
       updatedState.isPbEnrollConfirm=true,updatedState.enrolledCount=response.length,updatedState.pbEnroll=false;
      
    }
    else{
        updatedState.pbBulkEnrollConfirm=true,updatedState.isPbEnrollConfirm=false, updatedState.totalAccounts=response.length,updatedState.successCount=pbEnrollSuccessCount,updatedState.pbEnroll=false;
  }
   return updatedState;
}

//for enroll

  //for de enroll

  handle() {
    const updatedState = { ...this.state };
    if (this.customerData.emailAddresses.length) {
     let filtered = this.customerData.emailAddresses;
      filtered.map((emailSearch) => {
        updatedState.emails.push(emailSearch.email);
        if (emailSearch.standardIndicatorEmail === "X") {
          updatedState.primaryEmail = emailSearch.email;
        }
        if(emailSearch.record_guid!==null){
          updatedState.enrolledEmail=emailSearch;

        }
      });
       app.appService.setLocalStorage('pbemails', updatedState.emails);
      updatedState.toggleDisabled=false, this.setState(updatedState);
    }
  }
  togglePopup() {
    this.setState({ isOpen: !this.state.isOpen }, () => { });

  }

  paperlessToggle(enrollStatus) {
    const updatedState = { ...this.state };
    if (enrollStatus) {
      updatedState.pbEnroll = true;
    } else {
      updatedState.pbDeEnroll = true;
    }
    this.setState(updatedState, () => { });
    window.scrollTo(0,0);
  }

    inEligibleStatus = () =>{
    if (this.props.accountData.isEligible === "FALSE") 
        return true;
        else
        return false;     
  }


  cancelButtonHandler() { this.setState({ pbEnroll: false ,data:1}, () => { }); }
  
  cancelButtonHandlerTurnoffPopup() {
    this.setState({ pbDeEnroll: false }, () => { });
    this.setState({ deEnrollConfirmPopup: true }, () => { });
    this.setState({ yesCancelDeEnroll: false }, () => { });
  }
  cancelViewButtonHandlers() { this.setState({ viewEditPopUp: false, deEnrollConfirmPopup: true, yesCancelDeEnroll: false }, () => { }); }

  closeViewEditConfirmPopup(){ window.location.reload(); }

  closeButtonHandlerDeEnrollPopup(){
    this.setState({ deEnrollConfirmPopup: false }, () => { });
    window.location.reload();
  }

  popupCallback = (d,unselected,selectAllFlag,contractAccountCount) => {
    const updatedState = { ...this.state };
    updatedState.data = d,updatedState.unselected=unselected,updatedState.selectAllflag=selectAllFlag,updatedState.contractAccountCount=contractAccountCount,this.setState(updatedState);
}

overlayFocusController() {
  if(this.state.pbEnroll || this.state.pbDeEnroll || this.state.viewEditPopUp || this.state.pbBulkEnrollConfirm || this.state.isPbEnrollConfirm ) {
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
  } else {
    document.body.style.position = this.initialPositionValue;
    document.body.style.removeProperty("width");
  }
}
//-----------------------------ebill-----------------------------
getFormattedPreferenceData(Obj, type){
  let preferenceData={emailSet:[]};
  _.each(Obj.record, function(email){
      let preferenceSavedDateMilliSec = email.validFromDate ? email.validFromDate.indexOf('/')===0 ? email.validFromDate.slice(6,-2) : email.validFromDate : null;
      let preferenceSavedEDMDate = preferenceSavedDateMilliSec ? app.appUtil.DateUtil.getEDMDate(parseInt(preferenceSavedDateMilliSec)) : null;
      let data={
        solution: 'U', objectType: 'ISUACCOUNT', objectKey: email.relationshipObjectKey || '', contractAccountNumber: email.contractAccountNumber, category: 'PAPR', messageType: 'EBILL',
          buPartner: email.buPartner, channel: 'INT', recordGUID: email.recordGUID || 'NEW', email: email.value || "", type: type,
          validFromDate: email.validFromDate, validFromTime: email.validFromTime, validToDate: email.validToDate, validToTime: email.validToTime, removeFromDate: preferenceSavedEDMDate, buPartner2: email.buPartner2, relationshipObjectType: email.relationshipObjectType, relationshipObjectKey: email.relationshipObjectKey
      };
        preferenceData.emailSet.push(data);
  });
  return preferenceData;
}

handleViewEdit(){
  let preferenceData = this.getFormattedPreferenceData(this.props.ebillpaprSold, 'soldTo');
  let preferenceDataAuth = this.getFormattedPreferenceData(this.props.ebillpaprAuth, 'AuthTo');
  let accountData = this.props.accountData;
  let serviceAccountData = {
    'saAccList': [
      {
        'contractNumber': accountData.contractAccountNumber, 'email': '', 'houseNumber': accountData.houseNumber, 'unitNumber': '',
        'address': accountData.houseNumber + ' ' + accountData.streetAddress + ' ' + accountData.city + ' ' + accountData.state + ' ' + accountData.zipcode,
        'sreetAddress': accountData.streetAddress,
        'city': accountData.city,
        'state': accountData.state,
        'zipCode': accountData.zipcode,
        //'premiseNumber': accountData.premiseNumber,
        'serviceAddress': accountData.houseNumber + ' ' + accountData.streetAddress + ' ' + accountData.city + ' ' + accountData.state + ' ' + accountData.zipcode,
        'serviceAccountIndex': 0,
        'isSelected': true
      }
    ],
    'serviceAccountCount': 1
    };
    this.setState({preferenceData: preferenceData,dropDownData: this.props.dropDownData,serviceAccountData: serviceAccountData,preferenceDataAuth: preferenceDataAuth});
}
render() {
  this.overlayFocusController();
   return (
     <div>
     <PaperlessBilling AlertName2={this.props.AlertName2}  AlertName1={this.props.AlertName1} AlertExp={this.props.AlertExp} accountData={this.props.accountData} preferenceData={this.props.preferenceData} customerData={this.props.customerData} toggleChecked={this.state.checked} paperlessToggle={this.paperlessToggle.bind(this)}
          viewEditHandler={this.viewEditHandler.bind(this)} togglePopup={this.togglePopup.bind(this)} isOpen={this.state.isOpen} pbEnrollErrMsg={this.state.pbEnrollErrMsg}
          reason={this.inEligibleStatus() ? this.props.accountData.reason : null} isDisabled={this.state.toggleDisabled} staticContent={this.props.staticContent}
          errorPbDeEnrollMsg={this.state.errorPbDeEnrollMsg} onPbToggleOnOffClick={this.props.onPbToggleOnOffClick} ebillpaprRecord={this.props.ebillpaprRecord} />

        {(this.state.pbEnroll) ? <PaperlessBillingTurnonPopup containerCallback={this.popupCallback} data={this.state.data} contractAccountNumber={this.props.contractAccountNumber} contractAccountResults={this.state.cpcData.contractAccountResults} accType={this.state.AccType} accountData={this.props.accountData} nextStDate={this.props.accountData.nextStatementDate} cpcPageNumber={this.props.cpcPageNumber} bpNumber={this.props.cpcData.bpNumber}
            multiAccountData={this.props.cpcData} submitClick={this.submitClick} isOpen={this.cancelButtonHandler.bind(this)} primaryEmail={this.state.primaryEmail} isPbEnrollConfirm={this.state.isPbEnrollConfirm} currentPage={this.state.currentPage} contractAccountCount={this.props.contractAccountCount} pbEnrollErrMsg={this.state.pbEnrollErrMsg} pageChangeFlag={this.state.pageChangeFlag} /> : null
        }
        {(this.state.pbDeEnroll) ?<PaperlessBillingTurnoffPopup accountData={this.props.accountData} submitDeenrollClick={this.submitDeenrollClick} isOpen={this.cancelButtonHandlerTurnoffPopup.bind(this)} isPbDeEnrollConfirm={this.state.isPbDeEnrollConfirm} paprRecord={this.props.paprRecord} ebillpaprCount={null} /> : null}
        {(this.state.viewEditPopUp) ? <ViewEditPaperlessBilling emails={this.state.emails} loginEmail={app.appService.getUserInfo().email} accountData={this.props.accountData} isOpen={this.cancelViewButtonHandlers.bind(this)} primaryEmail={this.state.primaryEmail} enrolledEmail={this.props.preferenceData.email_id[0]} prefData={this.state.AccType==="Multi" ? this.props.prefData : this.props.singlePaprRecord.record} bpNumber={this.props.cpcData.bpNumber}  refreshPage={this.props.refreshPage} enrolledEmailObj={this.state.enrolledEmail} customerData={this.customerData} preferenceData={this.state.preferenceData} preferenceDataAuth={this.state.preferenceDataAuth} ebillpaprRecord={this.props.ebillpaprRecord} closePopUp={this.closeViewEditConfirmPopup.bind(this)} /> :null}
        {(this.state.pbBulkEnrollConfirm) ? <BulkEnrollConfPopup contractAccountResults={this.state.cpcData.contractAccountResults} failedAccounts={this.state.failedAccounts} enrolledCount={this.state.enrolledCount} primaryEmail={this.state.primaryEmail} isOpen={this.cancelButtonHandler.bind(this)} isConfOpen={this.cancelBulkConfirmationButtonHandlers.bind(this)} totalAccounts={this.state.totalAccounts} successCount={this.state.successCount} /> : null}
        {(this.state.isPbEnrollConfirm) ? <ConfirmationPopup nextStDate={this.props.accountData.nextStatementDate} enrolledCount={this.state.enrolledCount} primaryEmail={this.state.primaryEmail} accType={this.state.AccType} accountData={this.props.accountData} isOpen={this.cancelButtonHandler.bind(this)} isConfOpen={this.cancelConfirmationButtonHandlers.bind(this)} /> : null}
        {(this.state.deEnrollConfirmPopup) ? <PaperlessBillingDeEnrollConfirmPopup prefenceDataCount={null} accountData={this.props.accountData} closePopup={this.closeButtonHandlerDeEnrollPopup.bind(this)} yesCancelDeEnroll={this.state.yesCancelDeEnroll} ebillpaprCount={null} /> : null}

      </div>
    );

  }
}
export default PaperlessBillingContainer;
